import { getStates } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';

export const useGetStates = (tenantId: string, enabled = true) => {
  const { data, status } = useQuery(
    ['states', tenantId],
    () => getStates(tenantId),
    {
      enabled,
    }
  );

  return {
    states: data || [],
    statesStatus: status,
  };
};
